(function () {
  angular
    .module("akitabox.ui.dialogs.filePreview", [
      "ngMaterial",
      "akitabox.core.services.associatedText",
      "akitabox.core.services.document",
      "akitabox.core.services.user",
      "akitabox.core.toast",
      "akitabox.core.services.asset",
      "akitabox.core.services.pin",
      "akitabox.core.services.helpers",
      "akitabox.core.services.room",
      "akitabox.ui.dialogs",
      "akitabox.ui.dialogs.document.tag",
    ])
    .controller("FilePreviewDialogController", FilePreviewDialogController);

  /* @ngInject */
  function FilePreviewDialogController(
    // Angular
    $log,
    $scope,
    $q,
    $document,
    $timeout,
    $cookies,
    $rootScope,
    // Material
    $mdDialog,
    //Constants
    EVENT_MEDIA_ZOOM_IN,
    EVENT_MEDIA_ZOOM_OUT,
    EVENT_MEDIA_ZOOM_RESET,
    EVENT_PIN_REFRESH,
    CHECK_TEXT_RECOGNITION_TEXT_TOGGLE_COOKIE,
    // Services
    AssetService,
    AssociatedTextService,
    AttachmentService,
    ConfirmationDialog,
    DocumentService,
    DownloadDocumentDialog,
    OrganizationService,
    ServiceHelpers,
    RoomService,
    TagDocumentDialog,
    ToastService,
    // Models
    models
  ) {
    var self = this;

    // Constants
    var OCR_CONTENT_ID = "ocr-content";
    var OCR_HIGHLIGHT_CONTAINER_CLASS = "pre-process-ocr-highlight-container";
    var OCR_HIGHLIGHT_CANVAS_CLASS = "pre-process-ocr-highlight-canvas";
    var ABX_DESCRIPTION_ATTR = "abx-description";
    var ABX_ID_ATTR = "abx-text-id";
    var OCR_HIGHLIGHT_CLASS = "pre-process-ocr-highlight-box";
    var OCR_HIGHLIGHT_SELECTED_CLASS = "selected";
    var PIN_VALUES_ACCEPTED = ["string", "paragraph", "number", "float", "url"];
    var ORIENTATION_ROTATION = {
      1: 0,
      2: 0, // Flip across y-axis
      3: 180,
      4: 180, // Rotate 180 and flip across y-axis
      5: 90, // Rotate 90 and flip across y-axis
      6: 90,
      7: 270, // Rotate 270 and flip across y-axis
      8: 270,
    };
    var ANNOTATION_SHIFTS = [
      [0, 0], // 0. Center
      [1, 1], // 1. Top-right
      [1, 0], // 2. Right
      [1, -1], // 3. Bottom-right
      [0, -1], // 4. Bottom
      [-1, -1], // 5. Bottom-left
      [-1, 0], // 6. Left
      [-1, 1], // 7. Top-Left
      [0, 1], // 8. Top
    ];
    var ORIENTATION_SHIFT = {
      3: 0,
      4: 0,
      5: 5,
      6: 5,
      7: 5,
      8: 5,
    };

    // Private Attributes
    var highlightBoxes = [];
    var $highlightContainer;
    var $highlightCanvas;

    // Attributes
    self.selectedText = "";
    self.showControls = false;
    self.loading = true;
    self.ocrDisabled = true;
    self.annotationShift = 0;
    self.imageDimensions = null;
    self.imageOrientation = 0;
    self.imageRotation = 0;
    self.orientRotation = 0; // 90, 180, 270
    self.highlightRotation = 0;
    self.highlightShiftX = 0;
    self.highlightShiftY = 0;
    self.autoAlignAnnotations = true;
    self.validPinFields = [];
    self.organization = OrganizationService.getCurrent();
    self.recognizedTexts = [];
    self.pinUpdated = {};
    self.lastValueSelected = {};
    self.undoTimeout;
    self.attachments = [];
    self.totalOfAttachments = 1;
    self.currentAttachmentPosition = 1;
    self.entityType = self.pin.pinType.protected_type.toLowerCase();
    self.initialDocumentId = self.documentId;
    self.supportMultipleFiles = self.supportMultipleFiles || false;
    self.isToggled =
      $cookies.get(CHECK_TEXT_RECOGNITION_TEXT_TOGGLE_COOKIE) === "true";
    self.selectedTextRecognitionIds = [];
    self.isPDF = false;
    self.documentOrder = self.documentOrder || [];
    self.imageData;
    self.previousPinValue = {};

    // Functions
    self.cancel = $mdDialog.cancel;
    self.getRecognizedTextData = getRecognizedTextData;
    self.addAnnotations = addAnnotations;
    self.onRotate = onRotate;
    self.onInputChange = onInputChange;
    self.onInputClear = onInputClear;
    self.onClickLabel = onClickLabel;
    self.zoomIn = zoomIn;
    self.zoomOut = zoomOut;
    self.reset = reset;
    self.undoChange = undoChange;
    self.editTags = editTags;
    self.editDocumentName = editDocumentName;
    self.cancelEditDocumentName = cancelEditDocumentName;
    self.saveDocumentName = saveDocumentName;
    self.documentNameUpdated = documentNameUpdated;
    self.fetchAttachmentsDocument = fetchAttachmentsDocument;
    self.onDocumentPagination = onDocumentPagination;
    self.onDownload = onDownload;
    self.toggleHighlightBoxes = toggleHighlightBoxes;
    self.onDelete = onDelete;
    self.onInputBlur = onInputBlur;
    self.onInputSelected = onInputSelected;
    self.regenerateOCR = regenerateOCR;

    // Get Ocr data when <ocr-content></ocr-content> is on the DOM
    $scope.$watch(document.getElementById(OCR_CONTENT_ID), init);

    // =================
    // Public Functions
    // =================

    function init() {
      if (!self.pin) {
        self.cancel();
        ToastService.showError(
          "Error opening modal, initial parameters not defined"
        );
      } else {
        if (self.initialDocumentId) {
          fetchAttachmentsDocument();
          filterPinFields(self.pin.pinType.fields);
        } else {
          //This will load the values from a pin, when this is loaded from a bff
          getPinValues(self.pin).then((values) => {
            self.pin.values = values;
            fetchAttachmentsDocument();
            filterPinFields(self.pin.pinType.fields);
          });
        }
      }
    }

    /**
     * Retrieve OCR data to display on the image
     */
    function getRecognizedTextData(currentDocument, reprocessOCR = false) {
      ServiceHelpers.getDocumentData(currentDocument, true, reprocessOCR).then(
        (imageData) => {
          const {
            recognizedText: { recognizedTexts, errorMessage, ocrDisabled },
          } = imageData;

          if (errorMessage) {
            $log.error(errorMessage);
            ToastService.showError(errorMessage);
          }
          self.recognizedTexts = recognizedTexts;
          self.ocrDisabled = ocrDisabled;
          if (ocrDisabled) {
            self.isToggled = false;
          }
          currentDocument.prefetchData = imageData;
          self.document = currentDocument;
          self.loading = false;

          if (reprocessOCR) {
            toggleHighlightBoxes();
            self.loading = false;
          }
        }
      );
    }

    function filterPinFields(fields) {
      const validFields = fields.filter((field) =>
        PIN_VALUES_ACCEPTED.includes(field.data_type)
      );
      if (!validFields.length) return;

      self.validPinFields = filterPinValues(validFields, self.pin.values);
    }

    /**
     *
     * @param {pinFields} pinFields Array of pin fields that will be displayed in the ui
     * @param {array} pinValues Values that will be displayed next to the pin field
     * @returns A custom array of pin fields, pin value and assetId
     */
    function filterPinValues(pinFields, pinValues) {
      return pinFields.map((field) => {
        return {
          ...field,
          pin_value: pinValues[field._id].value,
          pin_value_id: pinValues[field._id]._id,
          is_editing_field: false,
        };
      });
    }

    /**
     * Create text highlight boxes and add them to the DOM
     *
     * @param {Object}  Event {dimensions, rotation, orientation}
     */
    function addAnnotations($event) {
      // Add highlight container
      var ocrContent = document.getElementById(OCR_CONTENT_ID);
      var highlightContainer = document.createElement("div");
      highlightContainer.setAttribute("class", OCR_HIGHLIGHT_CONTAINER_CLASS);
      $highlightContainer = angular.element(highlightContainer);

      var text = self.recognizedTexts ? self.recognizedTexts : null;
      if (!text || !ocrContent || !$highlightContainer) {
        return;
      }

      var dimensions = $event.dimensions;
      self.imageOrientation = $event.orientation;
      self.imageRotation = $event.rotation;
      self.orientRotation = ORIENTATION_ROTATION[self.imageOrientation];
      self.imageDimensions = dimensions;

      var imageWidth = dimensions.width;
      var imageHeight = dimensions.height;

      // radii for every highlight box (rect)
      const radii = 4;
      // gives extra space in every highlight box (rect)
      const offsetSize = 8;
      const offsetPosition = 4;
      // create canvas element with same size as image
      const highlightCanvas = document.createElement("canvas");
      highlightCanvas.classList.add(OCR_HIGHLIGHT_CANVAS_CLASS);
      highlightCanvas.width = imageWidth;
      highlightCanvas.height = imageHeight;
      // elevate canvas element on top of image
      highlightCanvas.style.top = "0";
      highlightCanvas.style.left = "0";
      highlightCanvas.style.position = "absolute";

      // put canvas in DOM within ocr section in file preview
      ocrContent.appendChild(highlightCanvas);

      let highlightCanvasCtx;
      if (highlightCanvas.getContext) {
        highlightCanvasCtx = highlightCanvas.getContext("2d");
        // opaque black for background rect
        highlightCanvasCtx.fillStyle = "rgba(0, 0, 0, 0.26)";
        highlightCanvasCtx.fillRect(0, 0, imageWidth, imageHeight);
        // keep background rect where it doesn't overlap with new shapes
        highlightCanvasCtx.globalCompositeOperation = "destination-out";
        highlightCanvasCtx.fillStyle = "rgba(255, 255, 255, 1)";
      }

      for (var i = 0; i < text.length; i++) {
        const { _id, top, left, bottom, right, text: value } = text[i];
        const { x, y, w, h } = {
          x: Number(left) - offsetPosition,
          y: Number(top) - offsetPosition,
          w: Number(right - left) + offsetSize,
          h: Number(bottom - top) + offsetSize,
        };

        if (highlightCanvasCtx) {
          // "punch holes" in background rect
          highlightCanvasCtx.beginPath();
          highlightCanvasCtx.roundRect(x, y, w, h, radii);
          highlightCanvasCtx.fill();
        }

        var el = document.createElement("div");

        // Styles
        el.style.left = `${x}px`;
        el.style.top = `${y}px`;
        el.style.width = `${w}px`;
        el.style.height = `${h}px`;
        el.style.borderRadius = `${radii}px`;
        el.classList.add(OCR_HIGHLIGHT_CLASS);

        // Attributes
        el.setAttribute("id", "ocr-box-id-" + i);
        el.setAttribute(ABX_DESCRIPTION_ATTR, value);
        el.setAttribute(ABX_ID_ATTR, _id);

        el.onclick = onBoxClick;

        highlightBoxes.push(el);
        highlightContainer.appendChild(el);
      }

      $highlightCanvas = angular.element(highlightCanvas);
      if (!self.isToggled) {
        $highlightCanvas.hide();
      }

      if ($highlightContainer) {
        $highlightContainer.css({
          position: "fixed",
          top: 0,
          left: 0,
          width: imageWidth,
          height: imageHeight,
        });
      }

      if (self.autoAlignAnnotations) {
        _alignAnnotations();
      }

      ocrContent.appendChild(highlightContainer);

      $scope.$apply(function () {
        self.showControls = false;
      });
      //Align the grids if the image is rotated
      rotateHighlightBoxes(self.document.rotation);
    }

    /**
     * Toggle highlight on/off.
     */
    function toggleHighlightBoxes() {
      if (self.isPDF) return;
      self.isToggled = !self.isToggled;
      $cookies.put(CHECK_TEXT_RECOGNITION_TEXT_TOGGLE_COOKIE, self.isToggled);
      if (self.isToggled) {
        $highlightCanvas.show();
      } else {
        clearSelectedBoxes();
        self.selectedText = "";
        $highlightCanvas.hide();
      }
      $timeout(function () {
        reset();
      }, 50);
    }

    /**
     * Reprocess OCR and Toggle green highlight boxes on/off.
     */
    function regenerateOCR() {
      self.loading = true;
      toggleHighlightBoxes();
      if (self.isPDF) return;
      self.recognizedTexts = null;
      self.ocrDisabled = null;
      getRecognizedTextData(self.attachment.document, true);
      $timeout(function () {
        reset();
      }, 50);
    }

    /**
     * Handle image rotated
     *
     * @param {Object}  Event {dimensions, rotation}
     */
    function onRotate(direction, $event) {
      const rotationDirection = direction === "left" ? -90 : 90;
      let rotation;
      if (self.document.rotation === 0 && direction === "left") {
        rotation = 360 + rotationDirection;
      } else {
        rotation = self.document.rotation + rotationDirection;
      }
      rotate(rotation);
    }

    /**
     * Set selected text to box description
     *
     * @param {Event} $event Event
     */
    function onBoxClick($event) {
      if (!self.isToggled) {
        toggleHighlightBoxes();
      }
      $scope.$apply(function () {
        $event.target.classList.toggle(OCR_HIGHLIGHT_SELECTED_CLASS);

        var description = $event.target.getAttribute(ABX_DESCRIPTION_ATTR);
        self.selectedTextRecognitionIds.push(
          $event.target.getAttribute(ABX_ID_ATTR)
        );

        const valueExist = self.selectedText
          .trim()
          .split(" ")
          .includes(description);
        if (valueExist)
          self.selectedText = self.selectedText
            .trim()
            .split(" ")
            .filter((val) => val !== description)
            .join(" ");
        else self.selectedText += " " + description;
      });
    }

    /**
     * This function will update the pin value, according to what
     * @param {pinValue} field The pin that will be updated
     */
    function onClickLabel(pinField) {
      const value = self.selectedText;
      self.lastValueSelected = pinField;
      saveChange(pinField, value);
    }

    function undoChange() {
      clearSelectedBoxes();
      self.showUndo = false;
      if (self.pin.pinType.is_room) {
        updateRoomValue(
          self.previousPinValue,
          self.previousPinValue.pin_value,
          true
        );
      } else {
        updateAssetValue(
          self.previousPinValue,
          self.previousPinValue.pin_value,
          true
        );
      }
    }

    function saveChange(pinField, value) {
      clearSelectedBoxes();
      self.previousPinValue = { ...self.lastValueSelected };
      if (self.pin.pinType.is_room) {
        updateRoomValue(pinField, value);
      } else {
        updateAssetValue(pinField, value);
      }
    }

    function editDocumentName() {
      self.newDocumentName = "";
      self.isEditing = true;
    }

    function cancelEditDocumentName() {
      self.newDocumentName = "";
      self.isEditing = false;
    }

    function saveDocumentName() {
      self.isSaving = true;
      DocumentService.rename(
        self.document.building,
        self.document._id,
        self.newDocumentName
      )
        .then((doc) => {
          self.document = doc;
          self.isEditing = false;
          if (self.supportMultipleFiles) {
            self.attachment.document = doc;
            $rootScope.$broadcast("attachments:update", {
              entityId: self.pin._id,
            });
          } else {
            $scope.$emit(EVENT_PIN_REFRESH);
          }
        })
        .catch(ToastService.showError)
        .finally(() => {
          self.isSaving = false;
        });
    }

    function documentNameUpdated(event) {
      self.newDocumentName = event.value;
    }

    function onInputBlur(e, pinField) {
      const value = e.target.value;
      if (
        self.lastValueSelected.pin_value === undefined || //is undefined when you update a field go to another and click undo
        value === self.lastValueSelected.pin_value.toString()
      ) {
        pinField.is_editing_field = false;
        self.lastValueSelected = {};
        return;
      }
      saveChange(pinField, value);
    }

    function onInputSelected(pinField) {
      if (pinField._id === self.lastValueSelected._id) return;
      self.lastValueSelected = { ...pinField };
      pinField.is_editing_field = true;
    }

    // =================
    // Private Functions
    // =================

    function _shiftAnnotations(shift) {
      if (shift === null || shift === undefined) {
        shift = self.annotationShift + 1;
      }
      if (shift === ANNOTATION_SHIFTS.length) {
        shift = 0;
      }
      if (self.annotationShift > 0) {
        // undo previous shift
        var currentShiftCoords = ANNOTATION_SHIFTS[self.annotationShift];
        var x = currentShiftCoords[0];
        var y = currentShiftCoords[1];
        if (x > 0) {
          x = -1;
        } else if (x < 0) {
          x = 1;
        }
        if (y > 0) {
          y = -1;
        } else if (y < 0) {
          y = 1;
        }
        shiftHighlightBoxes(self.imageDimensions, x, y);
      }
      // apply new shift
      self.annotationShift = shift;
      var shiftCoords = ANNOTATION_SHIFTS[shift];
      shiftHighlightBoxes(self.imageDimensions, shiftCoords[0], shiftCoords[1]);
      // update metadata
      var shiftX = shiftCoords[0];
      var shiftY = shiftCoords[1];
      self.highlightShiftX = shiftX > 0 ? "+1" : shiftX;
      self.highlightShiftY = shiftY > 0 ? "+1" : shiftY;
    }

    function _alignAnnotations() {
      if (self.orientRotation) {
        rotateHighlightBoxes(self.orientRotation);
      }

      if (self.imageRotation) {
        var annotationRotation = self.orientRotation + self.imageRotation;
        if (annotationRotation >= 360) {
          annotationRotation -= 360;
        }
        rotateHighlightBoxes(annotationRotation);
      }

      var annotationShift = ORIENTATION_SHIFT[self.imageOrientation] || 0;
      if (annotationShift > 0) {
        _shiftAnnotations(annotationShift);
      }
    }

    /**
     * Shift highlight boxes a distance (pixels) equal to the
     * difference between the image height and width (divided by 2)
     *
     * @param {Object} dimensions   Image dimensions (width, height, etc)
     * @param {Number} x            Shift box right/left (1/-1)
     * @param {Number} y            Shift box up/down (1/-1)
     */
    function shiftHighlightBoxes(dimensions, x, y) {
      var width = dimensions.width;
      var height = dimensions.height;
      var difference = Math.abs(width - height) / 2;

      var shifts = [];

      if (x > 0) {
        shifts.push(shiftRight);
      } else if (x < 0) {
        shifts.push(shiftLeft);
      }

      if (y > 0) {
        shifts.push(shiftUp);
      } else if (y < 0) {
        shifts.push(shiftDown);
      }

      if (shifts.length) {
        for (var i = 0; i < highlightBoxes.length; ++i) {
          var box = highlightBoxes[i];
          for (var j = 0; j < shifts.length; ++j) {
            box = shifts[j](box);
          }
          highlightBoxes[i] = box;
        }
      }

      function shiftUp(e) {
        e.style.top = parsePixels(e.style.top) - difference + "px";
        return e;
      }

      function shiftDown(e) {
        e.style.top = parsePixels(e.style.top) + difference + "px";
        return e;
      }

      function shiftLeft(e) {
        e.style.left = parsePixels(e.style.left) - difference + "px";
        return e;
      }

      function shiftRight(e) {
        e.style.left = parsePixels(e.style.left) + difference + "px";
        return e;
      }

      function parsePixels(pixels) {
        return pixels ? parseInt(pixels.replace("px", "")) : 0;
      }
    }

    function rotateHighlightBoxes(rotation) {
      self.highlightRotation = rotation;
      if (self.highlightRotation === 360) {
        self.highlightRotation = 0;
      }
      const rotate = { transform: `rotate(${self.highlightRotation}deg)` };
      [$highlightContainer, $highlightCanvas].forEach(($el) => {
        if ($el) $el.css(rotate);
      });
    }

    function onInputChange($event) {
      self.selectedText = $event.value;
      if (!$event.value) {
        self.selectedTextRecognitionIds = [];
      }
    }

    function onInputClear() {
      clearSelectedBoxes();
      self.selectedText = "";
      self.selectedTextRecognitionIds = [];
    }

    function updateRoomValue(pinField, value, isUndo) {
      const data = { value: value };
      RoomService.updateValue(
        self.pin.building,
        self.pin._id,
        pinField.pin_value_id,
        data
      )
        .then((pinResult) => {
          if (!isUndo) {
            showUndo(pinField, pinResult.value);
          }
          $scope.$emit(EVENT_PIN_REFRESH);
          return RoomService.getAllValues(pinField.building, self.pin._id);
        })
        .then((values) => {
          self.validPinFields = filterPinValues(self.validPinFields, values);
        })
        .catch((error) => {
          ToastService.showError(error);
          pinField.is_editing_field = false;
          pinField.pin_value = self.previousPinValue.pin_value;
        });
    }

    function updateAssetValue(pinField, value, isUndo) {
      const data = { value: value };
      AssetService.updateValue(
        self.pin.building,
        self.pin._id,
        pinField.pin_value_id,
        data
      )
        .then((pinResult) => {
          if (!isUndo) {
            showUndo(pinField, pinResult.value);
          }
          $scope.$emit(EVENT_PIN_REFRESH);
          if (self.selectedTextRecognitionIds.length) {
            associateTexts(self.pin._id, pinField);
          }
          $scope.$emit(EVENT_PIN_REFRESH);
          return AssetService.getAllValues(self.pin.building, self.pin._id);
        })
        .then((values) => {
          self.validPinFields = filterPinValues(
            self.validPinFields,
            values,
            self.pin._id
          );
        })
        .catch((error) => {
          ToastService.showError(error);
          pinField.is_editing_field = false;
          pinField.pin_value = self.previousPinValue.pin_value;
        });
    }

    function associateTexts(assetId, pin) {
      let requests = [];
      self.selectedTextRecognitionIds.forEach((selectedTextID) => {
        requests.push(associateText(assetId, pin, selectedTextID));
      });

      $q.all(requests)
        .then(() => {
          self.selectedTextRecognitionIds = [];
        })
        .catch(ToastService.showError);
    }

    function associateText(assetId, pin, recognizedTextId) {
      const data = {
        recognized_text: recognizedTextId,
        asset: assetId,
        label: pin.name,
      };
      return AssociatedTextService.create(data);
    }

    function rotate(rotation) {
      DocumentService.rotate(
        self.document.building,
        self.document._id,
        rotation % 360
      ).then(function (_document) {
        self.document = _document;
        if (self.supportMultipleFiles) {
          self.attachments[self.currentAttachmentPosition - 1].document =
            _document;
        }
        rotateImage(rotation);
        regenerateOCR();
        rotateHighlightBoxes(rotation);
      });
    }

    function clearSelectedBoxes() {
      highlightBoxes = highlightBoxes.map(function ($box) {
        $box.classList.remove(OCR_HIGHLIGHT_SELECTED_CLASS);
        return $box;
      });
    }

    function rotateImage(rotation) {
      let imageElement = $document.find("#ocr-content"); //$("#ocr-content");
      const degrees = rotation === 360 ? 0 : rotation;
      imageElement.find("img").css("transform", "rotate(" + degrees + "deg)");
    }

    function zoomIn() {
      $scope.$broadcast(EVENT_MEDIA_ZOOM_IN);
    }

    function zoomOut() {
      $scope.$broadcast(EVENT_MEDIA_ZOOM_OUT);
    }

    function reset() {
      $scope.$broadcast(EVENT_MEDIA_ZOOM_RESET);
    }

    function showUndo(pin, value) {
      self.showUndo = true;
      self.pinUpdated = {
        ...self.lastValueSelected,
        value: value,
        pin_value: value,
      };
      self.selectedText = "";
      if (self.undoTimeout) {
        //remove previous timeout before create a new one
        $timeout.cancel(self.undoTimeout);
      }
      self.undoTimeout = $timeout(function () {
        self.showUndo = false;
      }, 5000);
    }

    function editTags() {
      const options = {
        documents: [self.document],
        multiple: true,
      };

      TagDocumentDialog.show({ locals: options }).then(function (docs) {
        self.document = docs[0];
      });
    }

    function onDownload() {
      var locals = {
        docs: [self.document],
      };
      DownloadDocumentDialog.show({ locals: locals, multiple: true }).catch(
        ToastService.showError
      );
    }

    function fetchAttachmentsDocument() {
      if (
        angular.isString(self.entityType) &&
        !angular.isEmpty(self.entityType)
      ) {
        const validExtensions = models.DOCUMENT.FILE_PREVIEW_SUPPORTED_TYPES;

        // fetch for the attachments of the PIN, populate the self.attachments
        const params = {
          entity_id: self.pin._id,
          entity_type: self.entityType,
        };

        if (self.supportMultipleFiles) {
          AttachmentService.getAll(self.pin.building, params)
            .then(function (_attachments) {
              if (!angular.isEmpty(_attachments)) {
                const filteredAttachments = _attachments.filter((attachment) =>
                  validExtensions.includes(
                    attachment.document.extension.toLowerCase()
                  )
                );

                self.attachments = filteredAttachments;

                // If there is a document order, apply it to the attachments
                if (
                  self.documentOrder.length > 0 &&
                  self.documentOrder.length >= self.attachments.length
                ) {
                  const sortedAttachments = [];

                  self.documentOrder.forEach((documentId) => {
                    const attachment = self.attachments.find(
                      (attachment) => attachment.document._id === documentId
                    );
                    if (attachment) {
                      sortedAttachments.push(attachment);
                    }
                  });

                  if (self.attachments.length === sortedAttachments.length) {
                    self.attachments = sortedAttachments;
                  }
                }
                self.totalOfAttachments =
                  self.attachments.length === 0 ? 1 : self.attachments.length;

                // The initial document (the thumbnail that user clicked)
                // will be the first displayed
                const attachmentIndex = self.attachments.findIndex(
                  (attachment) =>
                    attachment.document._id === self.initialDocumentId
                );
                if (attachmentIndex >= 0) {
                  self.currentAttachmentPosition = attachmentIndex + 1;
                  self.attachment = self.attachments[attachmentIndex];
                } else {
                  self.attachment = self.attachments[0];
                }

                if (!isPDF(self.attachment.document.extension)) {
                  getRecognizedTextData(self.attachment.document);
                } else {
                  self.document = self.attachment.document;
                  self.isPDF = true;
                  self.loading = false;
                }
              }
            })
            .catch(function (error) {
              self.totalOfAttachments = 1;
              ToastService.showError(error);
            });
        } else {
          self.totalOfAttachments = 1;
          DocumentService.getById(self.pin.building, self.initialDocumentId)
            .then(function (_document) {
              if (isPDF(_document.extension)) {
                loadPDF(_document);
              } else {
                getRecognizedTextData(_document);
              }
            })
            .catch(function (error) {
              ToastService.showError(error);
            });
        }
      } else {
        $log.error(
          "FilePreviewController: entityType must defined " +
            "to enable image carousel"
        );
        ToastService.showError("Error to handle image");
      }
    }

    function onDocumentPagination(moveForward) {
      self.loading = true;
      let currentDocument = self.document;
      const move = moveForward ? 1 : -1;
      const attachmentCurrentIndex = self.attachments.findIndex(
        (_attachment) => _attachment.document._id === currentDocument._id
      );

      if (attachmentCurrentIndex >= 0) {
        // Check if it's the last item of the carousel. If yes, return to
        let newIndex =
          attachmentCurrentIndex + move === self.attachments.length
            ? 0
            : attachmentCurrentIndex + move;
        // If it should return to the last position
        newIndex = newIndex === -1 ? self.attachments.length - 1 : newIndex;
        self.attachment = self.attachments[newIndex];
        self.currentAttachmentPosition = newIndex + 1;
        if (!isPDF(self.attachment.document.extension)) {
          self.isPDF = false;
          getRecognizedTextData(self.attachment.document);
        } else {
          loadPDF(self.attachment.document);
        }
      } else {
        ToastService.showError("Document selected is not available");
      }
    }

    function loadPDF(document) {
      $timeout(function () {
        self.document = document;
        self.isPDF = true;
        self.recognizedTexts = null;
        self.ocrDisabled = true;
        self.loading = false;
      }, 10);
    }

    function isPDF(extension) {
      return extension.toLowerCase().contains("pdf");
    }

    function onDelete() {
      ConfirmationDialog.show({
        title: `${self.document.path}`,
        prompt: "Delete the Photo?",
        confirmText: "Ok",
        onConfirm: () => {
          if (self.supportMultipleFiles) {
            const attachment =
              self.attachments[self.currentAttachmentPosition - 1];
            if (!attachment) {
              return ToastService.showError(
                new Error("Cannot remove non-existent attachment")
              );
            }
            self.loading = true;
            const update = {
              action: "removeLink",
              entity_id: self.pin._id,
            };
            // Remove Remotely
            return AttachmentService.update(
              self.pin.building,
              attachment._id,
              update
            )
              .catch(ToastService.showError)
              .finally(function () {
                if (self.attachments.length === 1) {
                  self.cancel();
                } else {
                  // If the selected photo is the last,
                  // it must move forward the carousel
                  const forwardPagination =
                    self.currentAttachmentPosition === 1 ? true : false;

                  const indexOfAttachmentToDelete =
                    self.currentAttachmentPosition - 1;

                  onDocumentPagination(forwardPagination);

                  // Remove Locally
                  self.attachments.splice(indexOfAttachmentToDelete, 1);
                  self.currentAttachmentPosition = forwardPagination
                    ? self.currentAttachmentPosition - 1
                    : self.currentAttachmentPosition;
                  self.totalOfAttachments =
                    self.attachments.length === 0 ? 1 : self.attachments.length;
                }

                $rootScope.$broadcast("attachments:update", {
                  entityId: self.pin._id,
                });
              });
          }
        },
      });
    }

    function getPinValues(asset) {
      return AssetService.getAllValues(asset.building, asset._id);
    }
  }
})();
